import axios from 'axios';
import Vue from 'vue';
import xhrRoutes from './routes/xhr';
import Translator from './translator';

export default function () {
  const partnerCourses = new Vue({
    name: 'partnerCourses',
    el: '#js-partner-courses',
    delimiters: ['#{', '}'],
    data: {
      responseData: [],
      showMoreMessages: false,
      preload: false,
      loading: false,
    },
    methods: {
      load: function () {
        const self = this;
        self.preload = true;
        const data = xhrRoutes.partnerCourses.getCourses;

        axios.get(data.url, {
          params: data.params,
        })
          .then(function (response) {
            self.responseData = response.data.data;
            self.preload = false;

            if (self.responseData.length === 6) {
              self.showMoreMessages = true;
            }

            setTimeout(function () {
              app.msnryPc.rebuild();
            }, 50);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      update: function () {
        const self = this;
        const data = xhrRoutes.partnerCourses.getCourses;
        data.params.offset += data.params.limit;
        self.loading = true;

        axios.get(data.url, {
          params: data.params,
        })
          .then(function (response) {
            if (response.data.data.length < data.params.limit) {
              self.showMoreMessages = false;
            }

            self.loading = false;

            [].forEach.call(response.data.data, (function (element) {
              self.responseData.push(element);
            }));

            setTimeout(function () {
              app.msnryPc.add();
            }, 50);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      translateDay: function (day) {
        const translatedDay = Translator.trans(`date.day.${day.substr(0, 3)}`);
        return translatedDay[0].toUpperCase() + translatedDay.slice(1);
      },
      formatPrice: function (price) {
        return Number(parseFloat(price).toFixed(2)).toLocaleString('nl', {
          minimumFractionDigits: 2,
        });
      },
    },
    mounted: function () {
      const self = this;

      this.$nextTick(function () {
        self.load();
      });
    }
  });
};
